import React, { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import ApiConnection from '../utils/ApiConnection'
import Loader from '../utils/Loader'
import { IMAGE } from '../utils/Theme'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'

const Login = () => {

  const [email, setemail] = useState("")
  const [password, setpassword] = useState("")
  const [loading, setloading] = useState(false)
  const [type, setType] = useState('password');
  const [icon, setIcon] = useState( <FontAwesomeIcon icon={faEyeSlash} />);

  const navigate = useNavigate()

  const handleLogin = async ()=>{
  

      let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;

      if (reg.test(email) === false) {

          toast.error('Email should be proper!');
      } else if(password == ""){
          toast.error('Password should be must');
      } else {
          setloading(true)
          var FormData = require('form-data');
          var data = new FormData();
          data.append('email', email);
          data.append('password', password);
  
          try{
              const response = await ApiConnection.post('login', data)
              if(response?.data?.success) {
                  setloading(false)
                  console.log("user Info", response?.data?.token)
                  if(response?.data?.data?.token !== ""){
                      localStorage.setItem('ridedriver_access_token', response?.data?.data?.token)
                      localStorage.setItem('user', JSON.stringify(response?.data?.data?.user));
                
                      navigate('/#/dashboard')
                      window.location.reload()
              } else {
                  toast.info(response?.data?.message)
                  setloading(false)
              }
          }else {
              toast.info(response?.data?.message)
              setloading(false)
          }
          } catch(err){
              setloading(false)
              if(err.response?.status === 401){
              toast.error(err.response?.data?.message);   
          }
      }
  }

      

      //navigate("/dashboard")
  }
  const handleToggle = () => {
    if (type==='password'){
       setIcon(<FontAwesomeIcon icon={faEye} />);
       setType('text')
    } else {
       setIcon(<FontAwesomeIcon icon={faEyeSlash} />)
       setType('password')
    }
 }

  return (
    <div className='login-page container'>
               {loading && <Loader/>}
         <div className='login-page-inner'>
         <img src={IMAGE.darklogo} />
            <div className='card'>
         
            <div className='card-header'>
                  Login
              </div>
              <div className='card-body'>
                  <div className='form-group'>
                    <label>Email</label>
                    <input type="email" className="form-control" placeholder="Email"
                value={email}
                onChange={(e)=>setemail(e.target.value)}
                />
                  </div>
                  <div className='form-group'>
                    <label>Password</label>
                    <input type={type} className="form-control" placeholder="XXXXX"
                value={password}
                onChange={(e)=>setpassword(e.target.value)}
                />
                 <span class="flex justify-around items-center" style={{    
                    position: 'absolute',
top: '43px',
right: '18px'}} onClick={handleToggle}>
               {icon}
                  
                </span>
                  </div>
                  <h6 className='ml-2 text-right'> Forgot Password? <NavLink to="/forgot-password">Click Here</NavLink> </h6>
                  <div className='form-group'>
                    <button className='btn btn-primary'  onClick={handleLogin}>Login</button>
                  </div>
            </div>
            </div>
        </div>
    </div>
  )
}

export default Login